import React, { useEffect, useState } from 'react';

import SettingsSectionCard from '@/features/settings/components/SettingsSectionCard.jsx';
import { listWorkspaceMembers } from '../../api/workspacesApi';
import { WorkspaceAvatar } from '../WorkspaceSwitcher';
import '@/features/settings/components/settings.css';
import './WorkspaceSettingsTab.css';

export const WORKSPACE_READONLY_HEADING = 'Workspace details';
export const WORKSPACE_READONLY_NOTE = 'Only workspace Admins can change the name, logo or ownership.';

/**
 * Settings > Workspace for Editors and Viewers: the tab is every member's
 * landing page, so non-admins get a summary instead of disabled controls —
 * logo, name, owner, their own role and the active member count.  Nothing
 * here is new exposure: every value already reaches these roles through the
 * session (``/users/me``) and ``GET /workspaces/{id}/members``, which the
 * backend grants to Admin, Editor and Viewer alike.
 *
 * The member count is fetched on mount and counts only ``status: "active"``
 * rows (pending invitations are not members yet).  While it loads, or if the
 * request fails, the row shows an em dash rather than a stale number.
 */
const WorkspaceReadOnlyView = ({ workspace, role }) => {
    const [memberCount, setMemberCount] = useState(null);
    const workspaceId = workspace?.id;

    useEffect(() => {
        if (!workspaceId) return undefined;
        let cancelled = false;
        setMemberCount(null);
        listWorkspaceMembers(workspaceId).then((result) => {
            if (cancelled || !result.ok) return;
            const rows = Array.isArray(result.data?.members) ? result.data.members : [];
            setMemberCount(rows.filter((member) => member.status === 'active').length);
        });
        return () => {
            cancelled = true;
        };
    }, [workspaceId]);

    const facts = [
        { label: 'Name', value: workspace?.name || '—' },
        { label: 'Owner', value: workspace?.owner_email || '—' },
        { label: 'Your role', value: role || '—' },
        { label: 'Members', value: memberCount === null ? '—' : String(memberCount) },
    ];

    return (
        <SettingsSectionCard iconSlug="workspace" title="Workspace">
            <div className="settings-providers__panel">
                <h3 className="settings-subheading fs-unmask">{WORKSPACE_READONLY_HEADING}</h3>
                <div className="workspace-settings__summary">
                    <WorkspaceAvatar workspace={workspace} size="large" />
                    <dl className="workspace-settings__facts">
                        {facts.map(({ label, value }) => (
                            <div key={label} className="workspace-settings__fact">
                                <dt className="workspace-settings__fact-label fs-unmask">{label}</dt>
                                <dd className="workspace-settings__fact-value">{value}</dd>
                            </div>
                        ))}
                    </dl>
                </div>
                <p className="workspace-settings__readonly-note fs-unmask">{WORKSPACE_READONLY_NOTE}</p>
            </div>
        </SettingsSectionCard>
    );
};

export default WorkspaceReadOnlyView;
